import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { useIsCroatian } from "@/helpers/translation/useIsCroatian.ts";
import { Amenity } from "@/helpers/types/types.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * Retrieves translated information for an Amenity
 * Default App language is "hr"
 *     - if it's hr return directly the entity values
 *     - if it's not hr, check if there is a translation for the current language and return it,
 *       if not return the entity values
 * @param {Amenity} amenities The Amenity object to retrieve translated information for.
 * Returns an object containing the translated information
 */
export const useGetAmenityTranslated = (amenities: Amenity[]): string[] => {
  const { i18n } = useTranslation();
  const isCroatian = useIsCroatian();

  return useMemo(
    () =>
      amenities?.map((amenity) => {
        const translation = amenity.translations?.find(
          (t) => t.language === getLocale(i18n.language as Language),
        );
        return isCroatian ? amenity.description : translation?.description || amenity.description;
      }),
    [amenities, i18n.language, isCroatian],
  );
};
